import { accelerate, launch, start, reseller } from './images';
import {
  startComponents,
  somethingComponents,
  launchComponents,
  diyComponents,
  accelerateComponents,
} from './planComponents';
import {
  START,
  LAUNCH,
  ACCELERATE,
  EXPERT,
  DIY,
  DIY_YEARLY,
  DELUX,
  DELUX_YEARLY,
  EXPERT_NEW,
  SOMETHING,
  SOMETHING_YEARLY,
  EXPERT_5,
} from './constants';

import { plans as appSumoPlans } from './plansAppSumo';

const plans = {
  ...appSumoPlans,
  [SOMETHING]: {
    yearly_product_id: 'prod_KJhg98NknHCpae',
    monthly_product_id: 'prod_KJhjF6mWHcYvLs',
    title: 'Something',
    icon: start,
    components: somethingComponents,
    description:
      'Build your first app using a combination of interactive features, distribute it to your audience and engage them with Push notifications.',
    price: 14.99,
    year_price: 13.49,
    buttonTitle: 'CHOOSE PLAN',
    grayOut: false,
    united_states: {
      price: 10.98,
      year_price: 8.78,
      format: 'USD',
      currency: 'USD',
    },
    usd: {
      price: 10.98,
      year_price: 8.78,
    },
    austria: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    belgium: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    bulgaria: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    croatia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    cyprus: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    czechia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    denmark: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    estonia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    finland: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    france: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    germany: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    greece: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    hungary: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    ireland: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    italy: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    latvia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    lithuania: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    luxembourg: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    malta: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    netherlands: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    poland: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    portugal: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    romania: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    slovakia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    slovenia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    spain: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    sweden: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    eur: {
      price: 9.35,
      year_price: 7.5,
    },
    australia: {
      price: 15.03,
      year_price: 12.03,
      format: 'AUD',
      currency: 'AUD',
    },
    aud: {
      price: 15.03,
      year_price: 12.03,
    },
    new_zealand: {
      price: 15.49,
      year_price: 12.39,
      format: 'NZD',
      currency: 'NZD',
    },
    nzd: {
      price: 15.49,
      year_price: 12.39,
    },
    canada: {
      price: 13.89,
      year_price: 11.1,
      format: 'CAD',
      currency: 'CAD',
    },
    cad: {
      price: 13.89,
      year_price: 11.1,
    },
    south_africa: {
      price: 160.59,
      year_price: 128.51,
      format: 'ZAR',
      currency: 'ZAR',
    },
    zar: {
      price: 160.59,
      year_price: 128.51,
    },
  },

  [SOMETHING_YEARLY]: {
    yearly_product_id: 'prod_KJhg98NknHCpae',
    monthly_product_id: 'prod_KJhjF6mWHcYvLs',
    title: 'Something',
    hide: true,
    icon: start,
    components: somethingComponents,
    description:
      'Build your first app using a combination of interactive features, distribute it to your audience and engage them with Push notifications.',
    price: 14.99,
    year_price: 13.49,
    buttonTitle: 'CHOOSE PLAN',
    grayOut: false,
    united_states: {
      price: 10.98,
      year_price: 8.78,
      format: 'USD',
      currency: 'USD',
    },
    usd: {
      price: 10.98,
      year_price: 8.78,
    },
    austria: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    belgium: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    bulgaria: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    croatia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    cyprus: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    czechia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    denmark: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    estonia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    finland: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    france: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    germany: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    greece: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    hungary: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    ireland: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    italy: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    latvia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    lithuania: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    luxembourg: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    malta: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    netherlands: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    poland: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    portugal: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    romania: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    slovakia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    slovenia: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    spain: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    sweden: {
      price: 9.35,
      year_price: 7.5,
      format: 'EUR',
      currency: 'EUR',
    },
    eur: {
      price: 9.35,
      year_price: 7.5,
    },
    australia: {
      price: 15.03,
      year_price: 12.03,
      format: 'AUD',
      currency: 'AUD',
    },
    aud: {
      price: 15.03,
      year_price: 12.03,
    },
    new_zealand: {
      price: 15.49,
      year_price: 12.39,
      format: 'NZD',
      currency: 'NZD',
    },
    nzd: {
      price: 15.49,
      year_price: 12.39,
    },
    canada: {
      price: 13.89,
      year_price: 11.1,
      format: 'CAD',
      currency: 'CAD',
    },
    cad: {
      price: 13.89,
      year_price: 11.1,
    },
    south_africa: {
      price: 160.59,
      year_price: 128.51,
      format: 'ZAR',
      currency: 'ZAR',
    },
    zar: {
      price: 160.59,
      year_price: 128.51,
    },
  },

  [START]: {
    title: 'Start',
    icon: start,
    components: startComponents,
    buttonTitle: 'CHOOSE PLAN',
    grayOut: false,
  },

  [LAUNCH]: {
    title: 'Launch',
    icon: launch,
    components: launchComponents,
    description:
      'Perfect for businesses looking to build customer relationships and engage their audience.',
    price: 9.99,
    year_price: 7.99,
    buttonTitle: 'CHOOSE PLAN',
    grayOut: false,
    hide: true,
  },

  [DIY]: {
    yearly_product_id: 'prod_GKq5a4WGvttz9A',
    monthly_product_id: 'prod_GKq6Dif7FmXwNF',
    title: 'Anything',
    icon: launch,
    components: diyComponents,
    description:
      'Perfect for all you bold self-starters who know what you want. Customise a perfectly tailored app for you or your business.',
    price: 24.99,
    year_price: 22.49,
    buttonTitle: 'CHOOSE PLAN',
    grayOut: false,
    united_states: {
      price: 20,
      year_price: 16,
      format: 'USD',
      currency: 'USD',
    },
    usd: {
      price: 20,
      year_price: 16,
    },
    austria: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    belgium: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    bulgaria: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    croatia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    cyprus: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    czechia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    denmark: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    estonia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    finland: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    france: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    germany: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    greece: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    hungary: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    ireland: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    italy: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    latvia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    lithuania: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    luxembourg: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    malta: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    netherlands: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    poland: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    portugal: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    romania: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    slovakia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    slovenia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    spain: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    sweden: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    eur: {
      price: 16.99,
      year_price: 13.99,
    },
    australia: {
      price: 28,
      year_price: 25,
      format: 'AUD',
      currency: 'AUD',
    },
    aud: {
      price: 28,
      year_price: 25,
    },
    new_zealand: {
      price: 28,
      year_price: 25,
      format: 'NZD',
      currency: 'NZD',
    },
    nzd: {
      price: 28,
      year_price: 25,
    },
    canada: {
      price: 26,
      year_price: 22,
      format: 'CAD',
      currency: 'CAD',
    },
    cad: {
      price: 26,
      year_price: 22,
    },
    south_africa: {
      price: 240,
      year_price: 200,
      format: 'ZAR',
      currency: 'ZAR',
    },
    zar: {
      price: 240,
      year_price: 200,
    },
  },

  [DIY_YEARLY]: {
    yearly_product_id: 'prod_GKq5a4WGvttz9A',
    monthly_product_id: 'prod_GKq6Dif7FmXwNF',
    title: 'Anything',
    hide: true,
    icon: launch,
    components: diyComponents,
    description:
      'Perfect for all you bold self-starters who know what you want. Customise a perfectly tailored app for you or your business.',
    price: 24.99,
    year_price: 22.49,
    buttonTitle: 'CHOOSE PLAN',
    grayOut: false,
    united_states: {
      price: 20,
      year_price: 16,
      format: 'USD',
      currency: 'USD',
    },
    usd: {
      price: 20,
      year_price: 16,
    },
    austria: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    belgium: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    bulgaria: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    croatia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    cyprus: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    czechia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    denmark: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    estonia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    finland: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    france: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    germany: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    greece: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    hungary: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    ireland: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    italy: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    latvia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    lithuania: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    luxembourg: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    malta: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    netherlands: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    poland: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    portugal: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    romania: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    slovakia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    slovenia: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    spain: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    sweden: {
      price: 16.99,
      year_price: 13.99,
      format: 'EUR',
      currency: 'EUR',
    },
    eur: {
      price: 16.99,
      year_price: 13.99,
    },
    australia: {
      price: 28,
      year_price: 25,
      format: 'AUD',
      currency: 'AUD',
    },
    aud: {
      price: 28,
      year_price: 25,
    },
    new_zealand: {
      price: 28,
      year_price: 25,
      format: 'NZD',
      currency: 'NZD',
    },
    nzd: {
      price: 28,
      year_price: 25,
    },
    canada: {
      price: 26,
      year_price: 22,
      format: 'CAD',
      currency: 'CAD',
    },
    cad: {
      price: 26,
      year_price: 22,
    },
    south_africa: {
      price: 240,
      year_price: 200,
      format: 'ZAR',
      currency: 'ZAR',
    },
    zar: {
      price: 240,
      year_price: 200,
    },
  },

  [ACCELERATE]: {
    title: 'Accelerate',
    icon: accelerate,
    components: accelerateComponents,
    description:
      'Ideal for businesses looking to drive additional revenue from a mobile app.',
    price: 19.99,
    year_price: 15.99,
    buttonTitle: 'CHOOSE PLAN',
    grayOut: false,
    hide: true,
  },

  [DELUX]: {
    monthly_product_id: 'prod_GKq5FgQov1grlI',
    yearly_product_id: 'prod_GKq56VswwxJLht',
    title: 'Everything',
    icon: accelerate,
    components: accelerateComponents,
    description:
      'Why pick and choose features when you can have them all? Help your business increase revenue with a kickass mobile app – bells & whistles included.',
    price: 65,
    year_price: 58.5,
    buttonTitle: 'CHOOSE PLAN',
    grayOut: false,
    united_states: {
      price: 58,
      year_price: 52,
      format: 'USD',
      currency: 'USD',
    },
    usd: {
      price: 58,
      year_price: 52,
    },
    austria: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    belgium: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    bulgaria: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    croatia: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    cyprus: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    czechia: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    denmark: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    estonia: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    finland: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    france: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    germany: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    greece: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    hungary: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    ireland: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    italy: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    latvia: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    lithuania: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    luxembourg: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    malta: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    netherlands: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    poland: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    portugal: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    romania: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    slovakia: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    slovenia: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    spain: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    sweden: {
      price: 48,
      year_price: 42,
      format: 'EUR',
      currency: 'EUR',
    },
    eur: {
      price: 48,
      year_price: 42,
    },
    australia: {
      price: 76,
      year_price: 68,
      format: 'AUD',
      currency: 'AUD',
    },
    aud: {
      price: 76,
      year_price: 68,
    },
    new_zealand: {
      price: 76,
      year_price: 68,
      format: 'NZD',
      currency: 'NZD',
    },
    nzd: {
      price: 76,
      year_price: 68,
    },
    canada: {
      price: 72,
      year_price: 66,
      format: 'CAD',
      currency: 'CAD',
    },
    cad: {
      price: 72,
      year_price: 66,
    },
    south_africa: {
      price: 770,
      year_price: 690,
      format: 'ZAR',
      currency: 'ZAR',
    },
    zar: {
      price: 770,
      year_price: 690,
    },
  },

  [DELUX_YEARLY]: {
    title: 'Everything',
    icon: accelerate,
    components: accelerateComponents,
    description:
      'Why pick and choose features when you can have them all? Help your business increase revenue with a kickass mobile app – bells & whistles included.',
    price: 58.5,
    year_price: 702,
    buttonTitle: 'CHOOSE PLAN',
    grayOut: false,
    hide: true,
  },

  [EXPERT]: {
    title: 'Reseller',
    icon: reseller,
    components: accelerateComponents,
    description:
      'If your company is looking to enhance its product portfolio this is perfect tool that helps you to offer your customers stunning mobile apps',
    price: 250,
    year_price: 225,
    old_price: 120,
    old_year_price: 96,
    buttonTitle: 'CONTACT US',
    grayOut: true,
    united_states: {
      price: 210,
      year_price: 160,
      format: 'USD',
      currency: 'USD',
    },
    usd: {
      price: 210,
      year_price: 160,
    },
    austria: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    belgium: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    bulgaria: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    croatia: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    cyprus: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    czechia: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    denmark: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    estonia: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    finland: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    france: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    germany: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    greece: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    hungary: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    ireland: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    italy: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    latvia: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    lithuania: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    luxembourg: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    malta: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    netherlands: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    poland: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    portugal: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    romania: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    slovakia: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    slovenia: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    spain: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    sweden: {
      price: 180,
      year_price: 120,
      format: 'EUR',
      currency: 'EUR',
    },
    eur: {
      price: 180,
      year_price: 120,
    },
    australia: {
      price: 270,
      year_price: 190,
      format: 'AUD',
      currency: 'AUD',
    },
    aud: {
      price: 270,
      year_price: 190,
    },
    new_zealand: {
      price: 270,
      year_price: 190,
      format: 'NZD',
      currency: 'NZD',
    },
    nzd: {
      price: 270,
      year_price: 190,
    },
    canada: {
      price: 260,
      year_price: 175,
      format: 'CAD',
      currency: 'CAD',
    },
    cad: {
      price: 260,
      year_price: 175,
    },
    south_africa: {
      price: 2600,
      year_price: 1800,
      format: 'ZAR',
      currency: 'ZAR',
    },
    zar: {
      price: 2600,
      year_price: 1800,
    },
  },

  [EXPERT_NEW]: {
    title: 'Reseller',
    icon: reseller,
    components: accelerateComponents,
    description:
      'If your company is looking to enhance its product portfolio this is perfect tool that helps you to offer your customers stunning mobile apps',
    price: 150,
    year_price: 2700,
    buttonTitle: 'CONTACT US',
    grayOut: true,
    hide: true,
  },

  [EXPERT_5]: {
    title: 'Reseller',
    icon: reseller,
    components: accelerateComponents,
    description:
      'If your company is looking to enhance its product portfolio this is perfect tool that helps you to offer your customers stunning mobile apps',
    price: 150,
    year_price: 2700,
    buttonTitle: 'CONTACT US',
    grayOut: true,
    hide: true,
  },
};

export const oldPlansMapping = {
  [ACCELERATE]: DELUX,
  [LAUNCH]: DIY,
  [EXPERT]: EXPERT_NEW,
};

export default plans;
